import React, {Component} from 'react';
import {ErrorMessage, Field, Form, Formik} from "formik";
import {withTranslation} from "react-i18next";
import {Redirect} from "react-router";
import ErrorAlert from "../../../components/UI/ErrorAlert";
import AppContext from "../../../contexts/AppContext";

class Register extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.formSubmit = this.formSubmit.bind(this);
        this.handleConfirmProcessingDataChange = this.handleConfirmProcessingDataChange.bind(this);
        this.renderForm = this.renderForm.bind(this);

        this.state = {
            data: {
                subj_code: '',
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
            },
            confirm_processing_data_change: false,
            confirmationEmailSent: false,
            statusMsg: '',
            redirect_url: 'https://inbank.lt/ident/registracija',
        };
    }

    handleConfirmProcessingDataChange(event) {
        this.setState({confirm_processing_data_change: event.target.checked})
    }

    render() {
        if (this.state.redirect_url !== null && this.state.redirect_url !== undefined) {
            window.location.href = this.state.redirect_url;
            return null;
        }

        return (
            <div>
                <header className="text-white bg-primary-dark heading-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="heading-block__header">{this.props.t('become_a_customer')}</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="section window-layout">
                    <div className="container frame">
                        <div className="row">
                            {this.state.confirmationEmailSent &&
                            <div className="col-12">
                                <div className="alert alert-success my-5" role="alert">{this.state.statusMsg}</div>
                            </div>
                            }
                            <div className="col-12">
                                <ErrorAlert/>
                            </div>
                            {!this.state.confirmationEmailSent &&
                            <Formik
                                initialValues={this.state.data}
                                onSubmit={this.formSubmit}
                                render={this.renderForm}
                            />
                            }
                        </div>
                    </div>
                </div>
            </div>)
    }

    renderForm(props) {
        return (
            <Form className="form form-layout mt-5 pb-2">
                <div className="container form-layout__2-col">
                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="subj_code">{this.props.t('forms.personal_code')}</label>
                        <Field type="text" name="subj_code" id="subj_code"
                               className={'form-control' + (props.errors.subj_code && props.touched.subj_code ? ' is-invalid' : '')}/>
                        <ErrorMessage name="subj_code" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="first_name">{this.props.t('forms.first_name')}</label>
                        <Field type="text" name="first_name" id="first_name"
                               className={'form-control' + (props.errors.first_name && props.touched.first_name ? ' is-invalid' : '')}/>
                        <ErrorMessage name="first_name" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="last_name">{this.props.t('forms.last_name')}</label>
                        <Field type="text" name="last_name" id="last_name"
                               className={'form-control' + (props.errors.last_name && props.touched.last_name ? ' is-invalid' : '')}/>
                        <ErrorMessage name="last_name" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="email">{this.props.t('forms.email')}</label>
                        <Field type="text" name="email" id="email" autoComplete="email"
                               className={'form-control' + (props.errors.email && props.touched.email ? ' is-invalid' : '')}/>
                        <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="password">{this.props.t('forms.password')}</label>
                        <Field type="password" name="password" id="password" autoComplete={'new-password'}
                               className={'form-control' + (props.errors.password && props.touched.password ? ' is-invalid' : '')}/>
                        <small id="passwordHelpBlock"
                               className="form-text text-muted">{this.props.t('forms.password_help_text')}</small>
                        <ErrorMessage name="password" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label className="form-label"
                               htmlFor="password_confirmation">{this.props.t('forms.password_confirmation')}</label>
                        <Field type="password" name="password_confirmation" id="password_confirmation"
                               autoComplete={'new-password'}
                               className={'form-control' + (props.errors.password_confirmation && props.touched.password_confirmation ? ' is-invalid' : '')}/>
                        <ErrorMessage name="password_confirmation" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label htmlFor="confirm-processing-data">
                            <Field
                                name="confirm-processing-data"
                                id="confirm-processing-data"
                                type="checkbox"
                                value="true"
                                checked={this.state.confirm_processing_data_change}
                                onChange={this.handleConfirmProcessingDataChange}
                            >
                            </Field>

                            {[this.props.t('forms.i_have_read'), <a key="confirm-processing-data-label"
                                                                    href="https://inbank.lt/documents/lt/lt/privacy_policy.pdf"
                                                                    target="_blank">{this.props.t('forms.privacy_policy')}</a>]}
                        </label>
                    </div>

                    <div className="form-group col-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={props.isSubmitting || !this.state.confirm_processing_data_change}
                        >
                            {this.props.t('forms.sign_up_btn')}
                        </button>
                    </div>
                </div>
            </Form>
        );
    }

    formSubmit(values, actions) {
        const {clearError} = this.context;
        clearError();

        axios.post('/api/user/register', values)
            .then(
                data => {
                    actions.setSubmitting(false);

                    if (data.data.status === 'success') {
                        this.setState({confirmationEmailSent: true, statusMsg: data.data.message});
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }
}

export default withTranslation()(Register);
